import type { CustomDomainsTranslations } from '../interfaces/customDomains';

export const customDomainsTranslations: CustomDomainsTranslations = {
  eyebrow: 'Organización',
  title: 'Dominios propios',
  sub: 'Sirve el panel, la API y los correos desde los dominios de tu empresa. Tu DNS se queda donde está: solo publicas los registros que te mostramos.',
  disabled_title: 'No disponible en este entorno',
  disabled_text: 'Los dominios propios todavía no están habilitados aquí.',
  load_error: 'No pudimos cargar tus dominios. Intenta de nuevo.',

  kind_frontend_title: 'Panel',
  kind_frontend_desc: 'Tu equipo entra a {{brand}} desde, por ejemplo, app.tuempresa.com.',
  kind_backend_title: 'API',
  kind_backend_desc: 'La API, los webhooks y el panel en tu dominio usan, por ejemplo, api.tuempresa.com.',
  kind_email_title: 'Correo',
  kind_email_desc: 'Invitaciones, recuperación de contraseña y avisos salen desde tu dominio.',

  add: 'Configurar',
  verify_now: 'Verificar ahora',
  retry: 'Reintentar',
  delete: 'Quitar',
  cancel: 'Cancelar',
  copy: 'Copiar',
  copied: 'Copiado',
  history: 'Ver historial',
  hide_history: 'Ocultar historial',

  status_pending_dns: 'Esperando DNS',
  status_provisioning: 'Configurando',
  status_active: 'Activo',
  status_degraded: 'Con problemas',
  status_deleting: 'Quitando',
  status_deleted: 'Quitado',
  status_failed: 'Error',

  records_title: 'Registros DNS',
  records_intro: 'Crea estos registros en el proveedor DNS de tu dominio. Revisamos cada pocos minutos; también puedes pedir una verificación.',
  col_type: 'Tipo',
  col_name: 'Nombre',
  col_value: 'Valor',
  col_state: 'Estado',
  record_seen: 'Detectado',
  record_missing: 'Pendiente',
  purpose_routing: 'Apunta tu dominio a {{brand}}',
  purpose_ownership: 'Confirma que el dominio es tuyo',
  purpose_certificate_validation: 'Emisión del certificado HTTPS',
  purpose_dkim: 'Firma DKIM',
  purpose_mail_from_mx: 'MAIL FROM (rebotes)',
  purpose_mail_from_spf: 'SPF del MAIL FROM',
  purpose_dmarc: 'Política DMARC',

  note_dns_only: 'Si tu DNS está en Cloudflare, crea los CNAME en modo «Solo DNS» (nube gris).',
  note_acm_keep: 'No borres el registro del certificado: se usa para renovarlo automáticamente.',
  note_caa: 'Si tu dominio tiene registros CAA, autoriza a amazon.com, letsencrypt.org, pki.goog y ssl.com.',
  note_dmarc: 'Si ya tienes un DMARC en tu dominio no hace falta otro; el sugerido es el punto de partida.',
  note_relogin: 'Tu equipo deberá iniciar sesión otra vez al entrar por el nuevo dominio.',
  note_email_fallback: 'Hasta que quede activo, los correos siguen saliendo desde {{brand}}.',

  last_checked: 'Última revisión',
  last_error: 'Detalle',
  mail_from: 'Remitente',
  dmarc_policy: 'Política DMARC',
  never: 'Aún no',

  dialog_title: 'Configurar dominio',
  dialog_desc_frontend: 'Usa un subdominio (no el dominio raíz), por ejemplo app.tuempresa.com.',
  dialog_desc_backend: 'Usa un subdominio (no el dominio raíz), por ejemplo api.tuempresa.com.',
  dialog_desc_email: 'Puede ser tu dominio raíz o un subdominio dedicado al correo.',
  hostname_label: 'Dominio',
  hostname_placeholder_frontend: 'app.tuempresa.com',
  hostname_placeholder_backend: 'api.tuempresa.com',
  hostname_placeholder_email: 'tuempresa.com',
  hostname_required: 'Escribe un dominio.',
  from_local_part_label: 'Dirección',
  from_local_part_invalid: 'Usa solo letras, números, puntos, guiones o guion bajo.',
  from_name_label: 'Nombre del remitente',
  from_name_help: 'Lo que ven tus clientes junto a la dirección. Por defecto, {{brand}}.',
  from_name_invalid: 'No puede tener comillas ni los signos < >.',
  mail_from_subdomain_label: 'Subdominio del MAIL FROM',
  mail_from_subdomain_help: 'Recibe los rebotes y alinea SPF. Cámbialo solo si «mail» ya está en uso.',
  mail_from_subdomain_invalid: 'Usa solo letras minúsculas, números y guiones.',
  submit: 'Guardar y ver registros',

  delete_title: '¿Quitar este dominio?',
  delete_text: 'Dejará de funcionar de inmediato y retiraremos su certificado y configuración. Puedes volver a agregarlo después.',
  delete_confirm: 'Quitar dominio',

  toast_created: 'Dominio guardado. Publica los registros DNS para activarlo.',
  toast_deleted: 'Dominio quitado.',
  toast_verify: 'Verificación en curso.',
  toast_retry: 'Reintentando la configuración.',

  error_INVALID_HOSTNAME: 'Ese dominio no es válido.',
  error_APEX_NOT_ALLOWED: 'Usa un subdominio, no el dominio raíz.',
  error_RESERVED_DOMAIN: 'Ese dominio no se puede usar.',
  error_HOSTNAME_TAKEN: 'Ese dominio ya lo usa otra organización.',
  error_CUSTOM_DOMAIN_KIND_EXISTS: 'Ya tienes un dominio de este tipo. Quítalo primero para cambiarlo.',
  error_CUSTOM_DOMAINS_DISABLED: 'Los dominios propios no están habilitados en este entorno.',
  error_CUSTOM_FRONTEND_UNAVAILABLE: 'El panel en dominio propio no está disponible para esta plataforma.',
  error_generic: 'No pudimos completar la acción. Intenta de nuevo.',
};
